import { render, staticRenderFns } from "./generate-codes.vue?vue&type=template&id=a974145e&scoped=true&"
import script from "./generate-codes.vue?vue&type=script&lang=js&"
export * from "./generate-codes.vue?vue&type=script&lang=js&"
import style0 from "./generate-codes.vue?vue&type=style&index=0&id=a974145e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a974145e",
  null
  
)

export default component.exports